import React, { Suspense } from "react";
import createStore from "react-evoke";
import { AppLoadingScreen } from "../components/AppLoadingScreen";
import { AppActions } from "../typings/AppActions";
import { AppDerivedState } from "../typings/AppDerivedState";
import { AppState } from "../typings/AppState";
import { authActions } from "./actions/auth";
import { userActions } from "./actions/user";
import { derivedState } from "./derivedState";
import { initializers } from "./initializers";
import { initialState } from "./initialState";
import { roleActions } from "./actions/roles";
import { terminalActions } from "./actions/terminal";
import { itemReturnActions } from "./actions/itemReturn";
import { divisionActions } from "./actions/division";
import { statusActions } from "./actions/status";
import { permissionActions } from "./actions/permission";
import { userTypeActions } from "./actions/userType";
import { departmentActions } from "./actions/department";
import { creditCustomerActions } from "./actions/creditCustomers";
import { eodActions } from "./actions/eod";
import { configurationActions } from "./actions/posConfiguration";
import { storeConfigurationActions } from "./actions/storeConfiguration";
import { homeActions } from "./actions/home";
import { companyActions } from "./actions/company";
import { storeActions } from "./actions/store";
import { voucherActions } from "./actions/vouchers";
import { currencyActions } from "./actions/currency";
import { resyncActions } from "./actions/resync";

const { Store, UseStore, useStore } = createStore<
  AppState,
  AppActions,
  AppDerivedState
>();

export const AppStore = ({ children }: { children: React.ReactNode }) => (
  <>
    <Store
      actions={{
        ...authActions,
        ...userActions,
        ...roleActions,
        ...terminalActions,
        ...itemReturnActions,
        ...divisionActions,
        ...statusActions,
        ...permissionActions,
        ...userTypeActions,
        ...departmentActions,
        ...creditCustomerActions,
        ...eodActions,
        ...configurationActions,
        ...storeConfigurationActions,
        ...homeActions,
        ...companyActions,
        ...storeActions,
        ...voucherActions,
        ...currencyActions,
        ...resyncActions,
      }}
      initialState={initialState}
      initializers={initializers}
      derivedState={derivedState}
    >
      <Suspense fallback={<AppLoadingScreen />}>{children}</Suspense>
    </Store>
  </>
);

export { UseStore, useStore };
